export const templateUrlConfigTax = {
  taxpi92: './taxpi92Pkg.component.html',
  taxpi92_detail: './taxpi92-detailPkg.component.html',
  taxwc: './taxwc-editPkg.component.html',
  taxwd: './taxwd-editPkg.component.html',
}

export * from './taxwcPkg.service';
export * from './taxwc.service';
export * from './taxwdPkg.service';
export * from './taxwd.service';
